<template>
  <v-card>
    <v-card-subtitle class="pb-0">
      Geschäftspartner
    </v-card-subtitle>
    <v-card-title class="pt-0">
      {{ customer.name }}
    </v-card-title>
    <v-card-text>
      <v-alert
        :value="alert_succ"
        color="success"
        dark
        border="top"
        icon="mdi-home"
        transition="slide-y-transition"
        style="position: fixed;
        right: 5%;
        top: 150px;
        transform: translate(-50%, -50%);
        margin: 0 auto;"
      >
        Debitor erfolgreich gespeichert.
      </v-alert>

      <v-alert
        :value="alert_warn"
        color="warning"
        dark
        border="top"
        icon="mdi-home"
        transition="slide-y-transition"
        style="position: fixed;
        right: 5%;
        top: 150px;
        transform: translate(-50%, -50%);
        margin: 0 auto;"
      >
        Debitor konnte nicht gespeichert werden.
      </v-alert>
      <v-container>
        <v-row>
          <v-col cols="3">
            <v-text-field
              v-model="companyForm.customer_number"
              :error-messages="companyForm.errors.customer_number"
              label="Kundennummer"
            />
          </v-col>
          <v-col cols="3">
            <v-text-field
              v-model="companyForm.name"
              :error-messages="companyForm.errors.name"
              label="Name"
            />
          </v-col>
          <v-col cols="3">
            <v-text-field
              v-model="companyForm.website"
              :error-messages="companyForm.errors.website"
              label="Webseite"
            />
          </v-col>
          <v-col cols="3">
            <v-select
              v-model="companyForm.created_by"
              label="Zuständig"
              :items="users"
              :error-messages="companyForm.errors.created_by"
            />
          </v-col>
        </v-row>
        <v-row v-if="$page.props.user.permissions.offer.nwt_view">
          <v-col cols="3">
            <v-select
              v-model="customer.debitor_id"
              label="Debitor"
              :items="debitors"
              item-value="id"
              item-text="name"
              @change="updateDebitor"
            />
          </v-col>
        </v-row>
      </v-container>
    </v-card-text>
    <v-card-actions>
      <v-spacer />
      <v-btn color="primary" :loading="companyForm.processing" @click="save">
        speichern
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import axios from 'axios'
export default {
   props: {
      customer: {
         type: Object,
         required: true,
      },
      users: {
         type: Array,
         required: true,
      },
   },

   data () {
      return {
         tab: 0,
         dialog: false,
         companyForm: this.$inertia.form({
            customer_number: this.customer.customer_number,
            name: this.customer.name,
            name_short: this.customer.name_short,
            website: this.customer.website,
            created_by: this.customer.created_by,
         }),
         debitors: [],
         alert_succ: false,
         alert_warn: false,
      }
   },
   mounted: function () {
      this.loadDebitors()
   },
   methods: {
      save () {
         this.companyForm.patch(this.route('company.update', this.customer.id))
      },
      loadDebitors () {
         fetch(this.route('debitor.list'))
            .then(response => response.json())
            .then(data => (this.debitors = data.debitors))
      },
      updateDebitor () {
         axios.post(
            this.route('debitor.update.customer', {
               customer: this.customer.id
            }),
            {
               debitor_id: this.customer.debitor_id,
            }
         ).then(response => {
            if (response.data.msg === 'success') {
               // FlashMessages
               this.alert_succ = true
            } else {
               this.alert_warn = true
            }
            this.hide_alert()
         })
      },
      hide_alert: function (event) {
         // `event` is the native DOM event
         window.setTimeout(() => {
            this.alert_succ = false
            this.alert_warn = false
         }, 2000)
      }
   },
}
</script>
